module.exports = __webpack_public_path__ + "static/media/Thumbs.f1d035b8.db";